import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { path, equals } from "ramda";
import { ReducerKeys } from "../../reducers";
import { Row,Col,Card } from "antd";
import I18n from "../../i18n/";
import { Colors, Metrics } from "../../theme";
import Chart from "../../components/chart/index";
import GraphCard from "../../components/report/GraphCard";
import GraphConstant from "../../constants/graph";
import { TargetValueType, LoadingKey, CompareCol } from "./CompareValuePanel";
import { BreadcrumbPath } from "../../components/navigation/OBreadcrumb";
import { MathUtil, isFunction, isAlive, ArrayUtil, isFillAlive } from "../../util";
import { ContainerLoading, PreloadDiv } from "../../components/loading/PersistGateLoading";
import OrgUtil from "../../util/organize";
import { ColorSelection } from "../../components/button/ColorButton";

class ReportGenericPanel extends React.Component{
    state = {
    	loading: LoadingKey.Main,
    }
	mainValue = {};
    texts = {}

    constructor(props){
    	super(props);
    	const { setRef } = props;
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    	this.texts = { counseling: I18n.t("counseling") };
    }
    componentDidMount(){
    	const { fetchMain, targetValueType } = this.props;
    	this.updateMain(fetchMain(targetValueType), false);
    }
    updateMain(promise, errorOnInfo = true){
    	const { mainReadKey, onFetched } = this.props;
    	this.mainValue = undefined;
    	this.setState({loading: LoadingKey.Main});
    	promise.then(res=>{
    		this.mainValue = mainReadKey ? res[mainReadKey] : res;
    		if(isFunction(onFetched)){
    			onFetched(true, res, true);
    		}
    		this.setState({loading:LoadingKey.None});
    	}).catch(error=>{
    		this.mainValue = undefined;
    		if(isFunction(onFetched)){
    			onFetched(true, undefined, true);
    		}
    		console.error("fetchReport.updateMain.error: ",error);
    		this.setState({loading: LoadingKey.None});
    	});
    }
    shouldComponentUpdate(nextProps, nextState){
    	const { previousFetch, isVertical, targetValueType } = this.props;
    	const { loading } = this.state;
    	return (isVertical !== nextProps.isVertical) ||
            !equals(previousFetch, nextProps.previousFetch) ||
            (loading !== nextState.loading);
    }
    render(){
    	const { targetValueType, isVertical, drawListGraph,
    		header, exclude = [], previousFetch, dateRange, headKeys,
    		pushOnTypeClick
    	} = this.props;
    	const DrawListGraph = drawListGraph;
    	const { loading } = this.state;
    	return <div>
    		<ContainerLoading isLoading={loading === LoadingKey.Main} 
    			loadingChildren={<PreloadDiv />}>
    			<DrawListGraph 
    				summary={this.mainValue}
    				dateRange={dateRange}
    				headKeys={headKeys}
    				previousSummary={previousFetch ? previousFetch.main : undefined}
    				colorType={targetValueType}
    				isVertical={isVertical}
    				single={isVertical}
    				pushOnTypeClick={pushOnTypeClick}
    				showLegend={true}
    			/>
    		</ContainerLoading>
    	</div>;
    }
}

function state2props(state){
	return { organization: path([ReducerKeys.ORGANIZATION, "organization"], state)};
}
const DefaultGraphDrawer = (props)=><div>Draw graph here</div>;

ReportGenericPanel.defaultProps = {
	drawListGraph:DefaultGraphDrawer,
};

ReportGenericPanel.propTypes = {
	header:               PropTypes.string.isRequired,
	previousFetch:        PropTypes.object,
	fetchMain:            PropTypes.func.isRequired,
	onFetched:            PropTypes.func,
	exclude:              PropTypes.arrayOf(PropTypes.string),
	mainReadKey:          PropTypes.string,
	pushOnTypeClick:	  PropTypes.bool,
};
export default ReportGenericPanel;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/ReportGenericListOnlyPanel.js